/*
  Love'nSpa — widget de réservation (v2)

  Remplace l'iframe Bookingmood par un composant natif du thème.
  Contrat d'interface : projet LOVENSPA › claude/widget-reservation-contrats.md

  Structure du fichier
    1. Utilitaires (dates, argent, HTML)
    2. Configuration lue depuis le snippet Liquid
    3. Source de données : endpoint booking-availability, ou mock intégré
    4. État du widget
    5. Rendu : carte, calendrier, options, coordonnées
    6. Réservation : booking-create puis redirection vers le paiement
    7. Tracking : dataLayer (GTM) + funnel first-party (lovenspa-funnel.js)
    8. Repli sur l'iframe Bookingmood si l'API ne répond pas
    9. Initialisation paresseuse (IntersectionObserver)

  Aucun appel direct à gtag, fbq ou klaviyo ici : le widget pousse dans
  window.dataLayer, GTM décide selon le consentement.
*/

(function () {
  'use strict';

  // ------------------------------------------------------------------
  // 1. Utilitaires
  // ------------------------------------------------------------------

  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var JOURS_COURTS = ['lun', 'mar', 'mer', 'jeu', 'ven', 'sam', 'dim'];
  var JOURS_ABR = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];

  function aujourdhui() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function cle(d) {
    var m = d.getMonth() + 1, j = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (j < 10 ? '0' : '') + j;
  }

  function depuisCle(k) {
    var p = k.split('-');
    return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
  }

  function plusJours(d, n) {
    var r = new Date(d);
    r.setDate(r.getDate() + n);
    return r;
  }

  function premierDuMois(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1);
  }

  function moisSuivant(d, n) {
    if (n == null) n = 1;
    return new Date(d.getFullYear(), d.getMonth() + n, 1);
  }

  function nbNuits(a, b) {
    return Math.round((b - a) / 86400000);
  }

  function dateCourte(d) {
    return JOURS_ABR[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()].slice(0, 4) + '.';
  }

  function dateNumerique(d) {
    var j = d.getDate(), m = d.getMonth() + 1;
    return (j < 10 ? '0' : '') + j + '/' + (m < 10 ? '0' : '') + m + '/' + d.getFullYear();
  }

  function dateLongue(d) {
    return d.getDate() + ' ' + MOIS[d.getMonth()];
  }

  function euros(cents) {
    var e = Math.round(cents) / 100;
    var s = e % 1 === 0 ? String(e) : e.toFixed(2).replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }

  function echapper(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function estMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  // Le filtre Liquid `| json` échappe les apostrophes et les esperluettes en
  // entités HTML (d&#39;arrivée). Elles arrivent telles quelles dans le JSON,
  // et echapper() les ré-échapperait à l'affichage. On les décode donc à la
  // lecture de la configuration, une fois pour toutes.
  function decoderEntites(v) {
    if (typeof v === 'string') {
      if (v.indexOf('&') === -1) return v;
      var zone = decoderEntites._zone || (decoderEntites._zone = document.createElement('textarea'));
      zone.innerHTML = v;
      return zone.value;
    }
    if (Array.isArray(v)) return v.map(decoderEntites);
    if (v && typeof v === 'object') {
      var r = {};
      for (var k in v) if (Object.prototype.hasOwnProperty.call(v, k)) r[k] = decoderEntites(v[k]);
      return r;
    }
    return v;
  }

  var ICONES = {
    star: '<svg viewBox="0 0 24 24" class="lb-ico lb-ico--fill"><polygon points="12 2 15 8.5 22 9.3 17 14 18.5 21 12 17.8 5.5 21 7 14 2 9.3 9 8.5 12 2"/></svg>',
    prev: '<svg viewBox="0 0 24 24" class="lb-ico"><path d="m15 18-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" class="lb-ico"><path d="m9 18 6-6-6-6"/></svg>',
    close: '<svg viewBox="0 0 24 24" class="lb-ico"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    calendar: '<svg viewBox="0 0 24 24" class="lb-ico"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/><path d="m9 16 2 2 4-4"/></svg>',
    user: '<svg viewBox="0 0 24 24" class="lb-ico"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    pin: '<svg viewBox="0 0 24 24" class="lb-ico"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    card: '<svg viewBox="0 0 24 24" class="lb-ico"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20M7 15h4"/></svg>',
    shield: '<svg viewBox="0 0 24 24" class="lb-ico"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>'
  };

  // ------------------------------------------------------------------
  // 3. Source de données
  // ------------------------------------------------------------------

  // Mock déterministe, utilisé tant que booking-availability n'est pas déployé.
  //
  // Calé sur la configuration réelle de « Le Lien » relevée dans l'API
  // Bookingmood le 05/09 (contrat § 1bis) :
  //   • tarifs hébergeur : 220 € en semaine, 250 € le week-end, 370 € les jours
  //     spéciaux — ce sont bien des tarifs hébergeur, la commission s'ajoute ;
  //   • commission « Frais de service » : taxe on-top de 10 %, renvoyée dans
  //     `taxes[]` et affichée sur sa propre ligne, comme le fait Bookingmood.
  //     En vrai elle se lit dans products.fee.tax_ids et peut valoir autre
  //     chose (45 logements à 0 %, 2 à 12,01 %) ;
  //
  // Tous les `price_cents` sont donc des TARIFS HÉBERGEUR : la taxe est une
  // ligne du récapitulatif, pas un supplément noyé dans chaque prix.
  //   • remise dernière minute : −10 % si l'arrivée est à 4 jours ou moins ET
  //     tombe un lundi à jeudi. Elle n'est pas dans la grille tarifaire, elle
  //     est calculée — c'est pour ça que l'endpoint devra la refaire.
  //
  // Le tarif dégressif par rang de nuit (250 € la 1re, 235 € la 2e en WE) n'est
  // pas simulé ici : le calendrier n'affiche qu'un prix de nuit seule, et c'est
  // booking-quote qui fera foi sur un séjour. Voir contrat § 1ter.
  //
  // Indisponibilités pseudo-aléatoires (~35 %).
  function mockDispos(from, to) {
    var TAXE_ON_TOP = 0.10;
    var nights = [];
    var d = new Date(from);
    var limiteRemise = plusJours(aujourdhui(), 4);
    while (d <= to) {
      var w = d.getDay();
      var hote = (w === 5 || w === 6) ? 25000 : 22000;
      var t = Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
      var h = (t * 2654435761) % 100;
      if (h < 0) h += 100;
      // Restrictions réelles de la remise : advance_days ≤ 4 ET arrivée lun–jeu.
      var remise = d < limiteRemise && w >= 1 && w <= 4;
      var apresRemise = Math.round(hote * (remise ? 0.9 : 1));
      var n = {
        date: cle(d),
        price_cents: apresRemise,
        available: h > 34,
        check_in_ok: true
      };
      if (remise) {
        n.list_price_cents = hote;
        n.discount_label = 'Dernière minute';
      }
      nights.push(n);
      d = plusJours(d, 1);
    }
    return {
      currency: 'EUR',
      stale: false,
      rules: { min_duration: 1, max_duration: 7, min_advance_days: 0, max_advance_days: 365 },
      nights: nights,
      // Les 4 options payantes réelles de « Le Lien », relevées via
      // product_services → services. Ce sont des cases à cocher : Bookingmood
      // n'a pas de notion de quantité (type checkbox, pas de max_quantity).
      // `per_night` vient de fee.price.value[0].period : null = au séjour,
      // {duration:1} = par nuit (21 options sur 1 000 dans le parc).
      //
      // ATTENTION : `price_cents` est un PRIX VOYAGEUR, taxe comprise, comme
      // pour les nuits. Les options sont incluses dans bookings.subtotal, donc
      // elles subissent les taxes on-top au même titre que le loyer — un
      // préservatif à 2 € côté hébergeur se paie 2,20 €. Chaque option porte
      // ses propres fee.tax_ids, indépendants de ceux du produit : 5 options
      // du parc ne sont pas taxées, d'où le drapeau `taxable`.
      taxes: [{ label: 'Frais de service', type: 'on-top', percentage: 10 }],
      options: [
        { id: '4f0dc1cf', name: 'Champagne Autréau brut tradition', description: '', price_cents: 3000, taxable: true, per_night: false },
        { id: '13aaf806', name: 'Soft', description: '', price_cents: 200, taxable: true, per_night: false },
        { id: 'd8e14787', name: 'Préservatif', description: '', price_cents: 200, taxable: true, per_night: false },
        { id: '2d943137', name: 'Lubrifiant', description: '', price_cents: 400, taxable: true, per_night: false }
      ]
    };
  }

  function creerSource(config, surEchec) {
    var cache = {};      // clé 'YYYY-MM' → Promise
    var echecs = 0;

    function charger(from, to) {
      if (config.mock) {
        return new Promise(function (resolve) {
          window.setTimeout(function () { resolve(mockDispos(from, to)); }, 180);
        });
      }
      var url = config.endpoint + '/booking-availability?widget=' + encodeURIComponent(config.widget)
        + '&from=' + cle(from) + '&to=' + cle(to);
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('http_' + r.status);
        return r.json();
      }).then(function (json) {
        echecs = 0;
        return json;
      }).catch(function (e) {
        echecs += 1;
        if (echecs >= 2) surEchec(e, url);
        throw e;
      });
    }

    // Charge une fenêtre de deux mois à partir du 1er du mois demandé.
    function fenetre(mois) {
      var k = mois.getFullYear() + '-' + (mois.getMonth() + 1);
      if (!cache[k]) {
        var from = premierDuMois(mois);
        // booking-availability refuse une plage qui commence avant hier
        // (400 invalid_range). Le 1er du mois courant est donc hors limite
        // des le 3 du mois — et deux refus de suite faisaient basculer le
        // widget sur l'iframe. Les nuits passees ne sont de toute facon
        // jamais affichees : on part au plus tot d'hier.
        var mini = plusJours(aujourdhui(), -1);
        if (from < mini) from = mini;
        var to = plusJours(moisSuivant(mois, 2), -1);
        cache[k] = charger(from, to).catch(function (e) { delete cache[k]; throw e; });
      }
      return cache[k];
    }

    return { fenetre: fenetre };
  }

  // ------------------------------------------------------------------
  // 7. Tracking
  // ------------------------------------------------------------------

  function creerTracker(config) {
    var sessionId = null;
    try { sessionId = window.sessionStorage.getItem('lns_funnel_session'); } catch (e) { /* privé */ }

    var base = {
      item_id: config.handle,
      item_name: config.title,
      bm_widget: config.widget,
      session_id: sessionId,
      widget_version: 'v2'
    };

    // Correspondance dataLayer (GA4) → funnel first-party.
    var versFunnel = {
      lns_calendar_open: 'calendar_open',
      lns_no_availability: 'no_availability',
      lns_dates_selected: 'date_selected',
      lns_options_open: 'options_open',
      add_to_cart: 'option_add',
      remove_from_cart: 'option_remove',
      begin_checkout: 'checkout_start',
      lns_contact_submitted: 'contact_submitted',
      add_payment_info: 'booking_created',
      lns_booking_failed: 'booking_failed',
      lns_widget_fallback: 'widget_fallback'
    };

    function envoyer(nom, params) {
      params = params || {};
      var evt = { event: nom };
      for (var k in base) if (base[k] != null) evt[k] = base[k];
      for (var p in params) evt[p] = params[p];
      try {
        window.dataLayer = window.dataLayer || [];
        // Réinitialise ecommerce entre deux events GA4, recommandation Google.
        if (params.ecommerce) window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(evt);
      } catch (e) { /* jamais bloquant */ }

      var type = versFunnel[nom];
      if (!type) return;
      var payload = {};
      for (var q in params) if (q !== 'ecommerce') payload[q] = params[q];
      var options = { immediat: type === 'checkout_start' || type === 'booking_created' };
      try {
        if (window.LNS_FUNNEL && typeof window.LNS_FUNNEL.track === 'function') {
          window.LNS_FUNNEL.track(type, payload, options);
        } else {
          // lovenspa-funnel.js n'est pas encore chargé : il videra la file.
          window.LNS_FUNNEL_QUEUE = window.LNS_FUNNEL_QUEUE || [];
          window.LNS_FUNNEL_QUEUE.push([type, payload, options]);
        }
      } catch (e) { /* idem */ }
    }

    return { envoyer: envoyer };
  }

  // ------------------------------------------------------------------
  // Widget
  // ------------------------------------------------------------------

  function initialiser(racine) {
    var conteneur = racine.closest('.loven-dates') || racine.parentElement;
    var scriptConfig = conteneur.querySelector('[data-loven-booking-config]');
    if (!scriptConfig) return;

    var config;
    try { config = decoderEntites(JSON.parse(scriptConfig.textContent)); } catch (e) { return; }

    // Surcharges de test. Elles ne peuvent qu'etre demandees explicitement par
    // l'URL : sans parametre, config reste exactement ce que Liquid a rendu.
    if (MODE_DONNEES === 'live') config.mock = false;
    if (MODE_DONNEES === 'mock') config.mock = true;
    if (API_REF) config.endpoint = 'https://' + API_REF + '.supabase.co/functions/v1';
    var t = config.i18n || {};
    var tracker = creerTracker(config);
    var TODAY = aujourdhui();

    // ---- 4. État -----------------------------------------------------
    var S = {
      arr: null, dep: null,
      mois: premierDuMois(TODAY),
      ouvert: null,            // null | 'calendar' | 'options' | 'contact'
      opts: {},
      coupon: null,            // { code, label, cents } une fois validé
      couponErreur: null,
      couponEnCours: false,
      donnees: null,           // { nights: {date → n}, rules, options, stale }
      chargement: false,
      erreur: null,
      attemptId: uuid(),
      envoi: false,
      devis: null,             // réponse de booking-quote pour (dates, options, coupon)
      devisCle: null,          // URL du dernier devis demandé, pour dédoublonner
      devisEnCours: false,
      devisErreur: null,       // 'unavailable' | 'generic'
      etape: 1,                // 1 = identite + contact, 2 = adresse de facturation
      saisie: {}               // valeurs deja saisies, conservees d'une etape a l'autre
    };

    var source = creerSource(config, function (err, url) {
      // En mode preprod, retomber sur l'iframe reviendrait a cacher la panne
      // qu'on est justement venu observer. On affiche l'erreur brute a la
      // place : code, message et URL appelee.
      if (MODE_DONNEES === 'live') {
        afficherPanneTest(err, url);
        return;
      }
      basculerIframe('api_unavailable');
    });

    function afficherPanneTest(err, url) {
      var zone = racine.querySelector('.lb-mock--live') || racine;
      var bloc = document.createElement('p');
      bloc.className = 'lb-mock lb-mock--top lb-mock--panne';
      bloc.textContent = 'Preprod : l\'appel a echoue (' + (err && err.message ? err.message : 'erreur inconnue')
        + '). URL : ' + (url || config.endpoint + '/booking-availability');
      if (zone === racine) racine.insertBefore(bloc, racine.firstChild);
      else zone.parentNode.replaceChild(bloc, zone);
    }

    // ---- Données -----------------------------------------------------
    function nuit(d) {
      return S.donnees && S.donnees.nights[cle(d)] || null;
    }

    function chargerMois(mois) {
      S.chargement = true;
      rendre();
      return source.fenetre(mois).then(function (json) {
        if (!S.donnees) S.donnees = { nights: {}, rules: json.rules || {}, options: json.options || [], taxes: json.taxes || [], stale: !!json.stale };
        (json.nights || []).forEach(function (n) { S.donnees.nights[n.date] = n; });
        if (json.options && json.options.length) S.donnees.options = json.options;
        if (json.taxes) S.donnees.taxes = json.taxes;
        S.donnees.rules = json.rules || S.donnees.rules;
        S.chargement = false;
        S.erreur = null;
        rendre();
        verifierDisponibiliteMois();
      }).catch(function () {
        S.chargement = false;
        S.erreur = 'load';
        rendre();
      });
    }

    var moisSignales = {};
    function verifierDisponibiliteMois() {
      if (S.ouvert !== 'calendar') return;
      var m = S.mois, k = cle(m).slice(0, 7);
      if (moisSignales[k]) return;
      var d = new Date(m), fin = moisSuivant(m), libre = false;
      while (d < fin) {
        var n = nuit(d);
        if (n && n.available && d >= TODAY) { libre = true; break; }
        d = plusJours(d, 1);
      }
      moisSignales[k] = true;
      if (!libre) tracker.envoyer('lns_no_availability', { month_shown: k });
    }

    // ---- Calculs -----------------------------------------------------
    function nuits() { return S.arr && S.dep ? nbNuits(S.arr, S.dep) : 0; }

    // ---- Prix affiches : tarif hebergeur partout ------------------------
    // Decision du 06/09 : le calendrier et les options montrent le tarif
    // hebergeur, comme Bookingmood, et la commission n'apparait que sur sa
    // ligne du recapitulatif. booking-availability renvoie le prix voyageur
    // dans price_cents et, quand il le peut, le tarif hebergeur dans
    // host_price_cents. On ne prend le tarif hebergeur que si l'on peut
    // l'afficher juste : une nuit remisee sans host_list_price_cents
    // reste en prix voyageur plutot que d'afficher un prix faux.
    function prixNuitAffiche(n) {
      if (!n) return { cents: 0, avant: null };
      var remisee = n.list_price_cents != null && n.list_price_cents > n.price_cents;
      if (n.host_price_cents != null && (!remisee || n.host_list_price_cents != null)) {
        return { cents: n.host_price_cents, avant: remisee ? n.host_list_price_cents : null };
      }
      return { cents: n.price_cents, avant: remisee ? n.list_price_cents : null };
    }

    function prixOptionAffiche(o) {
      return o.host_price_cents != null ? o.host_price_cents : o.price_cents;
    }

    function lignesNuits() {
      var l = [], d = new Date(S.arr);
      while (d < S.dep) {
        var n = nuit(d);
        l.push({
          date: new Date(d),
          cents: prixNuitAffiche(n).cents,
          avant: prixNuitAffiche(n).avant,
          remise: n ? n.discount_label : null
        });
        d = plusJours(d, 1);
      }
      return l;
    }

    function totalNuits() {
      return lignesNuits().reduce(function (s, l) { return s + l.cents; }, 0);
    }

    // Détail du récapitulatif : nuits au tarif plein, puis chaque remise sur sa
    // propre ligne, nommée. Une remise silencieuse n'est pas une remise — le
    // visiteur doit voir ce qu'il gagne et pourquoi. Bookingmood l'enregistre
    // de la même façon, en ligne de facture « Last Minute ».
    function detailRecap() {
      if (S.devis) return recapDepuisDevis();
      var lignes = lignesNuits(), n = nuits(), rows = [];

      if (lignes.length <= 3) {
        lignes.forEach(function (l) {
          rows.push({ label: dateCourte(l.date), cents: l.avant || l.cents });
        });
      } else {
        var brut = lignes.reduce(function (s, l) { return s + (l.avant || l.cents); }, 0);
        rows.push({ label: n + ' ' + t.nights, cents: brut });
      }

      // Remises regroupées par libellé : deux nuits remisées font une ligne.
      var parLibelle = {}, ordre = [];
      lignes.forEach(function (l) {
        if (!l.avant || l.avant <= l.cents) return;
        var k = l.remise || t.discount;
        if (parLibelle[k] === undefined) { parLibelle[k] = 0; ordre.push(k); }
        parLibelle[k] += l.avant - l.cents;
      });
      ordre.forEach(function (k) {
        rows.push({ label: k, cents: parLibelle[k], remise: true });
      });

      optionsChoisies().forEach(function (l) {
        rows.push({
          label: l.opt.name + (l.opt.per_night && n > 1 ? ' × ' + n + ' ' + t.nights : ''),
          cents: l.cents
        });
      });

      if (S.coupon) {
        rows.push({ label: S.coupon.label || t.coupon, cents: S.coupon.cents, remise: true });
      }

      rows.push({ label: t.touristTax, valeur: t.included });

      // Sous-total puis taxes, comme le récapitulatif Bookingmood. Garder la
      // même structure évite les écarts d'arrondi et rend la réconciliation
      // avec bookings.subtotal / bookings.total immédiate.
      var taxes = lignesTaxes();
      if (taxes.length) {
        rows.push({ label: t.subtotal, cents: sousTotal(), sousTotal: true });
        taxes.forEach(function (tx) { rows.push({ label: tx.label, cents: tx.cents }); });
      }
      return rows;
    }

    // Code de réduction : cartes cadeaux et promos, émises côté Bookingmood
    // comme des coupons (voir issue-gift-card). La validation est faite par le
    // serveur, jamais ici : le widget n'invente pas de remise.
    function rendreCoupon() {
      if (S.coupon) {
        return '<div class="lb-coupon lb-coupon--ok">'
          + '<span class="lb-coupon__code">' + echapper(S.coupon.code) + '</span>'
          + '<button type="button" class="lb-coupon__remove" data-act="coupon-off">' + echapper(t.couponRemove) + '</button>'
          + '</div>';
      }
      return '<div class="lb-coupon">'
        + '<input type="text" class="lb-coupon__input" data-lb-coupon placeholder="' + echapper(t.couponPlaceholder) + '"'
        + ' autocomplete="off" autocapitalize="characters" spellcheck="false"'
        + (S.couponEnCours ? ' disabled' : '') + '>'
        + '<button type="button" class="lb-coupon__apply" data-act="coupon-on"' + (S.couponEnCours ? ' disabled' : '') + '>'
        + echapper(S.couponEnCours ? t.couponChecking : t.couponApply) + '</button>'
        + (S.couponErreur ? '<p class="lb-coupon__error">' + echapper(S.couponErreur) + '</p>' : '')
        + '</div>';
    }

    function appliquerCoupon() {
      var champ = racine.querySelector('[data-lb-coupon]');
      var code = champ ? champ.value.trim().toUpperCase() : '';
      if (!code) return;
      S.couponErreur = null;
      S.couponEnCours = true;
      rendre();

      if (config.mock) {
        window.setTimeout(function () {
          S.couponEnCours = false;
          S.couponErreur = t.couponUnknown;
          rendre();
        }, 500);
        return;
      }

      // Le devis serveur fait foi : on lui repasse le séjour complet et il
      // renvoie le coupon validé et son montant.
      var url = config.endpoint + '/booking-quote?widget=' + encodeURIComponent(config.widget)
        + '&arrival=' + cle(S.arr) + '&departure=' + cle(S.dep)
        + '&options=' + encodeURIComponent(optionsChoisies().map(function (l) { return l.opt.id; }).join(','))
        + '&coupon=' + encodeURIComponent(code);
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, json: j }; }); })
        .then(function (res) {
          S.couponEnCours = false;
          var remise = res.json && res.json.discounts && res.json.discounts.filter(function (d) { return d.coupon; })[0];
          if (res.status === 200 && remise) {
            S.coupon = { code: code, label: remise.label, cents: Math.abs(remise.cents) };
            demanderDevis();
            tracker.envoyer('lns_coupon_applied', { coupon: code, value: Math.abs(remise.cents) / 100 });
          } else {
            S.couponErreur = t.couponUnknown;
            tracker.envoyer('lns_coupon_rejected', { coupon: code });
          }
          rendre();
        })
        .catch(function () {
          S.couponEnCours = false;
          S.couponErreur = t.errGeneric;
          rendre();
        });
    }

    function rendreRecap() {
      var h = '<div class="lb-recap">';
      detailRecap().forEach(function (r) {
        var valeur;
        if (r.valeur) valeur = '<span class="lb-recap__free">' + echapper(r.valeur) + '</span>';
        else if (r.remise) valeur = '<span class="lb-recap__off">− ' + euros(r.cents) + '</span>';
        else valeur = euros(r.cents);
        h += '<div class="lb-recap__row' + (r.sousTotal ? ' is-subtotal' : '') + '"><span>'
          + echapper(r.label) + '</span><span>' + valeur + '</span></div>';
      });
      h += '<div class="lb-recap__total"><span>' + echapper(t.totalLabel) + '</span><span>' + euros(total()) + '</span></div>';
      return h + '</div>';
    }

    // Une option cochée coûte son prix, multiplié par le nombre de nuits
    // seulement si elle est facturée par nuit (fee.price.value[0].period).
    // ---- Devis serveur -------------------------------------------------
    // Des que les deux dates sont posees, le prix est celui de booking-quote et
    // de personne d'autre : tarif degressif par rang de nuit, remises, taxes,
    // coupon — tout est calcule la-bas, arrondi une seule fois. Le widget se
    // contente d'afficher les lignes et de renvoyer total_cents tel quel dans
    // expected_total_cents. Le calcul local (totalNuits, lignesTaxes…) ne sert
    // plus qu'au mock et a l'instant qui precede la reponse.
    function urlDevis() {
      return config.endpoint + '/booking-quote?widget=' + encodeURIComponent(config.widget)
        + '&arrival=' + cle(S.arr) + '&departure=' + cle(S.dep)
        + '&options=' + encodeURIComponent(optionsChoisies().map(function (l) { return l.opt.id; }).join(','))
        + (S.coupon ? '&coupon=' + encodeURIComponent(S.coupon.code) : '');
    }

    function demanderDevis() {
      if (config.mock || !S.arr || !S.dep) { S.devis = null; S.devisCle = null; return; }
      var url = urlDevis();
      if (url === S.devisCle && (S.devis || S.devisEnCours)) return;
      S.devisCle = url;
      S.devisEnCours = true;
      S.devisErreur = null;
      rendre();
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, json: j }; }); })
        .then(function (res) {
          if (url !== S.devisCle) return;   // une demande plus recente a pris le relais
          S.devisEnCours = false;
          if (res.status === 200 && res.json && typeof res.json.total_cents === 'number') {
            S.devis = res.json;
            rendre();
            return;
          }
          S.devis = null;
          var code = res.json && res.json.error;
          if (code === 'unavailable') {
            // Le calendrier etait en retard sur la realite : on retire les
            // dates, on recharge le mois et on le dit.
            S.devisErreur = 'unavailable';
            S.arr = null; S.dep = null;
            S.donnees = null;
            chargerMois(S.mois);
            return;
          }
          S.devisErreur = 'generic';
          rendre();
        })
        .catch(function () {
          if (url !== S.devisCle) return;
          S.devisEnCours = false;
          S.devis = null;
          S.devisErreur = 'generic';
          rendre();
        });
    }

    // Lignes du recapitulatif a partir du devis serveur, dans la structure
    // Bookingmood : nuits au tarif hebergeur, options, remises, taxe de sejour,
    // sous-total, frais de service, total. Tolerant aux deux orthographes du
    // contrat (taxes/fees, rate_cents/cents) pour ne pas casser sur un detail.
    function recapDepuisDevis() {
      var d = S.devis, rows = [], n = nuits();
      var nuitsDevis = d.nights || [];
      if (nuitsDevis.length <= 3) {
        nuitsDevis.forEach(function (x) {
          rows.push({ label: dateCourte(new Date(x.date + 'T00:00:00')), cents: x.rate_cents != null ? x.rate_cents : x.cents });
        });
      } else {
        rows.push({ label: n + ' ' + t.nights, cents: d.host_rent_cents != null ? d.host_rent_cents
          : nuitsDevis.reduce(function (a, x) { return a + (x.rate_cents != null ? x.rate_cents : x.cents); }, 0) });
      }
      (d.options || []).forEach(function (o) {
        rows.push({ label: o.label || o.name, cents: o.cents });
      });
      (d.discounts || []).forEach(function (r) {
        rows.push({ label: r.label || t.discount, cents: Math.abs(r.cents), remise: true });
      });
      rows.push({ label: t.touristTax, valeur: t.included });
      var taxes = d.taxes || d.fees || [];
      if (taxes.length) {
        rows.push({ label: t.subtotal, cents: d.host_subtotal_cents, sousTotal: true });
        taxes.forEach(function (tx) {
          rows.push({ label: tx.label + ' (+' + String(tx.percentage).replace('.', ',') + ' %)', cents: tx.cents });
        });
      }
      return rows;
    }

    function optionsChoisies() {
      var r = [], n = nuits() || 1;
      (S.donnees ? S.donnees.options : []).forEach(function (o) {
        if (!S.opts[o.id]) return;
        r.push({ opt: o, cents: prixOptionAffiche(o) * (o.per_night ? n : 1) });
      });
      return r;
    }

    // Sous-total hébergeur : nuitées (remises déduites) + options − coupon.
    // Le coupon s'applique avant les taxes : Bookingmood le traite comme une
    // ligne de facture négative dans le sous-total.
    function sousTotal() {
      var v = totalNuits() + totalOptions() - (S.coupon ? S.coupon.cents : 0);
      return v < 0 ? 0 : v;
    }

    // Taxes « on-top » du logement, calculées sur la SOMME et arrondies une
    // seule fois — c'est ainsi que Bookingmood calcule, et c'est la seule
    // façon de tomber au centime près sur son total.
    function lignesTaxes() {
      var base = sousTotal();
      return ((S.donnees && S.donnees.taxes) || []).map(function (tx) {
        return {
          label: tx.label + ' (+' + String(tx.percentage).replace('.', ',') + ' %)',
          cents: Math.round(base * tx.percentage / 100)
        };
      });
    }

    function totalOptions() {
      return optionsChoisies().reduce(function (s, l) { return s + l.cents; }, 0);
    }

    // Au branchement de booking-quote : prendre SON total_cents tel quel,
    // sans le recalculer ici. Cette version locale n'existe que pour le mock.
    function total() {
      if (S.devis) return S.devis.total_cents;
      return sousTotal() + lignesTaxes().reduce(function (s, l) { return s + l.cents; }, 0);
    }

    function regles() { return (S.donnees && S.donnees.rules) || {}; }

    // Une date est-elle choisissable comme arrivée / départ ?
    function arriveePossible(d) {
      var n = nuit(d);
      return !!(n && n.available && n.check_in_ok !== false && d >= TODAY);
    }

    function departPossible(d) {
      if (!S.arr || d <= S.arr) return false;
      var min = regles().min_duration || 1, max = regles().max_duration || 30;
      var n = nbNuits(S.arr, d);
      if (n < min || n > max) return false;
      // Toutes les nuits entre l'arrivée et la veille du départ doivent être libres.
      var c = new Date(S.arr);
      while (c < d) {
        var x = nuit(c);
        if (!x || !x.available) return false;
        c = plusJours(c, 1);
      }
      return true;
    }

    // ---- 5. Rendu ----------------------------------------------------
    function rendre() {
      var n = nuits(), ok = n > 0;
      var h = '<div class="lb-card">';
      if (config.mock) h += '<p class="lb-mock lb-mock--top">' + echapper(t.mockNotice) + '</p>';
      else if (MODE_DONNEES === 'live') {
        h += '<p class="lb-mock lb-mock--top lb-mock--live">Mode preprod : donnees reelles'
          + (API_REF ? ' (' + echapper(API_REF) + ')' : '') + '</p>';
      }

      // En-tête prix
      h += '<div class="lb-head"><div>';
      if (ok) {
        h += '<div class="lb-price"><span class="lb-price__amount">' + euros(total()) + '</span>'
          + '<span class="lb-price__unit">' + echapper(t.total) + '</span></div>'
          + '<div class="lb-price__sub">' + n + ' ' + echapper(n > 1 ? t.nights : t.night) + ' · ' + echapper(t.travelers) + '</div>';
      } else {
        h += '<div class="lb-price"><span class="lb-price__from">' + echapper(t.from) + '</span>'
          + '<span class="lb-price__amount">' + euros(config.fromPriceCents) + '</span>'
          + '<span class="lb-price__unit">' + echapper(t.perNight) + '</span></div>'
          + '<div class="lb-price__sub">' + echapper(t.travelers) + '</div>';
      }
      h += '</div>';
      // La note Judge.me reste affichée par le thème dans l'en-tête de la
      // colonne (loven-product-reviews) : on ne la duplique pas ici.
      h += '</div>';

      // Bloc dates — le filet foncé, c'est lui qu'on voit en premier
      var ouvertCal = S.ouvert === 'calendar';
      h += '<div class="lb-dates' + (ouvertCal ? ' is-open' : '') + '" data-act="calendar">'
        + '<button type="button" class="lb-dates__cell" data-act="calendar"><span class="lb-dates__label">' + echapper(t.arrival) + '</span>'
        + '<span class="lb-dates__value' + (S.arr ? '' : ' is-empty') + '">' + (S.arr ? dateNumerique(S.arr) : echapper(t.addDate)) + '</span></button>'
        + '<button type="button" class="lb-dates__cell" data-act="calendar"><span class="lb-dates__label">' + echapper(t.departure) + '</span>'
        + '<span class="lb-dates__value' + (S.dep ? '' : ' is-empty') + '">' + (S.dep ? dateNumerique(S.dep) : echapper(t.addDate)) + '</span></button>'
        + '</div>';

      if (ouvertCal) h += rendreCalendrier();

      // Options : trois visibles, le reste en popin
      var options = S.donnees ? S.donnees.options : [];
      if (options.length) {
        h += '<div class="lb-options"><div class="lb-options__title">' + echapper(t.addToStay) + '</div><div class="lb-options__list">';
        options.slice(0, 3).forEach(function (o) { h += rendreOption(o, false); });
        h += '</div>';
        if (options.length > 3) {
          h += '<button type="button" class="lb-options__more' + (S.ouvert === 'options' ? ' is-open' : '') + '" data-act="options">'
            + echapper(t.showOptions).replace('{count}', options.length) + '</button>';
        }
        h += '</div>';
        if (S.ouvert === 'options') h += rendreOptionsPopin(options);
      }

      // Récapitulatif
      if (ok) {
        h += rendreCoupon();
        h += rendreRecap();
      }

      // CTA
      if (ok) {
        // Le CTA attend le devis serveur : on n'affiche jamais un total que le
        // serveur n'a pas confirme. En cas d'erreur le bouton reste actif : un
        // clic redemande le devis (voir demarrerReservation).
        var attente = !config.mock && S.devisEnCours;
        h += '<button type="button" class="btn btn--primary btn--full lb-cta" data-act="book"' + (attente ? ' disabled' : '') + '>'
          + (attente ? echapper(t.quoteLoading) : echapper(t.book) + ' · ' + euros(total())) + '</button>';
        if (S.devisErreur === 'unavailable') h += '<p class="lb-error">' + echapper(t.errUnavailable) + '</p>';
        else if (S.devisErreur === 'generic') h += '<p class="lb-error">' + echapper(t.errGeneric) + '</p>';
      } else {
        h += '<button type="button" class="btn btn--primary btn--full lb-cta" data-act="calendar">' + echapper(t.seeAvailability) + '</button>'
          + '<p class="lb-hint">' + echapper(t.priceExactHint) + '</p>';
      }

      if (S.erreur === 'load') h += '<p class="lb-error">' + echapper(t.errGeneric) + '</p>';

      // Réassurance sous le CTA. Uniquement des faits vérifiables ; le reste
      // viendra du métaobjet.
      h += '<div class="lb-trust">';
      // Annulation. Deux sources, dans cet ordre :
      //  1. la date limite calculee, des que les dates sont choisies — c'est
      //     l'information la plus concrete pour le voyageur ;
      //  2. a defaut, le texte libre de l'hebergement (metafield
      //     hebergement.annulation_texte), visible des l'arrivee sur la fiche.
      // Quand les deux existent, le texte libre devient le sous-titre de la
      // date : il precise ce que « annulable » veut dire ici.
      var annulPosee = false;
      if (ok && config.cancelDaysBefore != null) {
        var limite = plusJours(S.arr, -Number(config.cancelDaysBefore));
        if (limite > TODAY) {
          h += ligneTrust(
            ICONES.calendar,
            echapper(t.cancelUntil).replace('{date}', dateLongue(limite)),
            echapper(config.cancelText || t.cancelHint)
          );
          annulPosee = true;
        }
      }
      // Sans dates, on affiche quand meme le delai : « Annulation gratuite —
      // Jusqu'a 10 jours avant l'arrivee ». C'est un argument de reservation,
      // il ne doit pas attendre que le voyageur ait choisi ses dates.
      if (!annulPosee) {
        var sousTitreAnnul = config.cancelDaysLabel || config.cancelText;
        if (sousTitreAnnul) {
          if (config.cancelDaysLabel && config.cancelText) {
            sousTitreAnnul = config.cancelDaysLabel + ' \u00b7 ' + config.cancelText;
          }
          h += ligneTrust(ICONES.calendar, echapper(t.cancelTitle), echapper(sousTitreAnnul));
        }
      }
      if (config.staysCount > 0) {
        h += ligneTrust(ICONES.user, echapper(t.stays).replace('{count}', config.staysCount), echapper(t.certifiedHost));
      }
      h += ligneTrust(ICONES.card, echapper(t.klarna), echapper(t.klarnaHint));
      h += '</div>';

      h += '</div>';
      if (S.ouvert === 'contact') h += rendreContact();
      if (S.ouvert && estMobile()) h += '<div class="lb-backdrop" data-act="close"></div>';

      racine.innerHTML = h;
      racine.classList.toggle('is-open', !!S.ouvert);
      majBarreSticky();
      positionnerPopin();
    }

    // La colonne de droite du thème est un conteneur sticky en overflow: auto,
    // qui rognerait une popin en position absolute. On la positionne donc en
    // fixed, ancrée sous le bloc dates (desktop uniquement ; mobile = bottom sheet).
    function positionnerPopin() {
      var pop = racine.querySelector('.lb-pop');
      if (!pop || estMobile()) return;
      var ancre = pop.classList.contains('lb-pop--calendar')
        ? racine.querySelector('.lb-dates')
        : racine.querySelector('.lb-options__more') || racine.querySelector('.lb-dates');
      var r = ancre.getBoundingClientRect(), rc = racine.getBoundingClientRect();
      var largeur = Math.min(pop.classList.contains('lb-pop--calendar') ? 700 : rc.width + 16, window.innerWidth - 32);
      pop.style.position = 'fixed';
      pop.style.top = Math.round(r.bottom + 8) + 'px';
      pop.style.right = Math.max(16, Math.round(window.innerWidth - rc.right - 8)) + 'px';
      pop.style.left = 'auto';
      pop.style.width = Math.round(largeur) + 'px';
      pop.style.maxHeight = Math.round(window.innerHeight - r.bottom - 24) + 'px';
    }

    window.addEventListener('scroll', function () { if (S.ouvert && S.ouvert !== 'contact') positionnerPopin(); }, { passive: true });
    window.addEventListener('resize', function () { if (S.ouvert) rendre(); });

    function ligneRecap(a, b) {
      return '<div class="lb-recap__row"><span>' + a + '</span><span>' + b + '</span></div>';
    }

    function ligneTrust(ico, titre, sous) {
      return '<div class="lb-trust__item">' + ico + '<div><div class="lb-trust__title">' + titre + '</div>'
        + (sous ? '<div class="lb-trust__sub">' + sous + '</div>' : '') + '</div></div>';
    }

    function rendreOption(o, complet) {
      var coche = !!S.opts[o.id];
      var prix = euros(prixOptionAffiche(o)) + (o.per_night ? ' ' + t.perNight : '');
      return '<label class="lb-opt' + (coche ? ' is-on' : '') + '">'
        + '<span class="lb-opt__box' + (coche ? ' is-on' : '') + '" aria-hidden="true"></span>'
        + '<input type="checkbox" class="lb-opt__input" data-act="opt" data-id="' + echapper(o.id) + '"' + (coche ? ' checked' : '') + '>'
        + '<span class="lb-opt__txt"><span class="lb-opt__name">' + echapper(o.name) + '</span>'
        + (complet && o.description ? '<span class="lb-opt__desc">' + echapper(o.description) + '</span>' : '') + '</span>'
        + '<span class="lb-opt__price">' + prix + '</span>'
        + '</label>';
    }

    function rendreOptionsPopin(options) {
      var h = '<div class="lb-pop lb-pop--options" role="dialog" aria-label="' + echapper(t.optionsTitle) + '">'
        + '<div class="lb-pop__head"><div><div class="lb-pop__title">' + echapper(t.optionsTitle).replace('{count}', options.length) + '</div>'
        + '<div class="lb-pop__hint">' + echapper(t.optionsHint) + '</div></div>'
        + '<button type="button" class="lb-pop__close" data-act="close" aria-label="' + echapper(t.close) + '">' + ICONES.close + '</button></div>'
        + '<div class="lb-options__list lb-options__list--full">';
      options.forEach(function (o) { h += rendreOption(o, true); });
      var choisies = optionsChoisies();
      h += '</div><div class="lb-pop__foot"><span>' + (choisies.length ? choisies.length + ' · ' + euros(totalOptions()) : '') + '</span>'
        + '<button type="button" class="lb-link" data-act="close">' + echapper(t.close) + '</button></div></div>';
      return h;
    }

    function rendreCalendrier() {
      var nbMois = estMobile() ? 1 : 2;
      var h = '<div class="lb-pop lb-pop--calendar" role="dialog" aria-label="' + echapper(t.chooseDates) + '">'
        + '<div class="lb-pop__head"><div><div class="lb-pop__title">' + echapper(t.chooseDates) + '</div>'
        + '<div class="lb-pop__hint">' + echapper(config.mock ? t.mockRates : (S.arr && !S.dep ? t.selectDeparture : t.priceUnderDate)) + '</div></div>'
        + '<div class="lb-nav"><button type="button" class="lb-nav__btn" data-act="prev"' + (S.mois <= premierDuMois(TODAY) ? ' disabled' : '') + ' aria-label="' + echapper(t.prevMonth) + '">' + ICONES.prev + '</button>'
        + '<button type="button" class="lb-nav__btn" data-act="next" aria-label="' + echapper(t.nextMonth) + '">' + ICONES.next + '</button></div></div>'
        + '<div class="lb-months lb-months--' + nbMois + '">';
      for (var i = 0; i < nbMois; i++) h += rendreMois(moisSuivant(S.mois, i));
      h += '</div>';
      if (S.chargement) h += '<div class="lb-loading" aria-hidden="true"></div>';
      h += '<div class="lb-pop__foot"><div class="lb-legend">'
        + '<span><i class="lb-dot lb-dot--free"></i>' + echapper(t.available) + '</span>'
        + '<span><i class="lb-dot lb-dot--sel"></i>' + echapper(t.yourDates) + '</span>'
        + '<span><i class="lb-dot lb-dot--busy"></i>' + echapper(t.booked) + '</span></div>'
        + '<button type="button" class="lb-link" data-act="clear">' + echapper(S.arr ? t.clearDates : t.close) + '</button></div></div>';
      return h;
    }

    function rendreMois(m) {
      var y = m.getFullYear(), mo = m.getMonth();
      var premier = new Date(y, mo, 1), dernier = new Date(y, mo + 1, 0);
      var decal = (premier.getDay() + 6) % 7;
      var h = '<div class="lb-month"><div class="lb-month__name">' + MOIS[mo] + ' ' + y + '</div><div class="lb-dow">';
      JOURS_COURTS.forEach(function (j) { h += '<span>' + j + '</span>'; });
      h += '</div><div class="lb-grid">';
      for (var e = 0; e < decal; e++) h += '<span class="lb-day lb-day--empty"></span>';
      for (var j = 1; j <= dernier.getDate(); j++) {
        var d = new Date(y, mo, j), n = nuit(d), tm = d.getTime();
        var choisirDepart = S.arr && !S.dep;
        var cliquable = choisirDepart ? (departPossible(d) || arriveePossible(d)) : arriveePossible(d);
        var estSel = (S.arr && tm === S.arr.getTime()) || (S.dep && tm === S.dep.getTime());
        var dans = S.arr && S.dep && tm > S.arr.getTime() && tm < S.dep.getTime();
        var libre = n && n.available && d >= TODAY;
        var cls = 'lb-day' + (estSel ? ' is-sel' : '') + (dans ? ' is-in' : '') + (!libre ? ' is-busy' : '');
        h += '<button type="button" class="' + cls + '" data-act="day" data-t="' + tm + '"' + (cliquable ? '' : ' disabled') + '>'
          + '<b>' + j + '</b><i' + (config.mock ? ' class="is-mock"' : '') + '>'
          + (libre && n
              ? (prixNuitAffiche(n).avant
                  ? '<s>' + euros(prixNuitAffiche(n).avant).replace(' €', '') + '</s> '
                  : '') + euros(prixNuitAffiche(n).cents).replace(' €', '&nbsp;€')
              : '&nbsp;')
          + '</i></button>';
      }
      return h + '</div></div>';
    }

    function rendreContact() {
      var n = nuits();
      var h = '<div class="lb-modal-overlay" data-act="close-contact"><div class="lb-modal" role="dialog" aria-modal="true" aria-labelledby="lb-modal-title">'
        + '<button type="button" class="lb-modal__close" data-act="close-contact" aria-label="' + echapper(t.close) + '">' + ICONES.close + '</button>'
        + '<div class="lb-modal__grid"><div class="lb-modal__main">'
        + '<h3 id="lb-modal-title" class="lb-modal__title">' + echapper(t.oneMoreStep) + '</h3>'
        + '<p class="lb-modal__lede">' + echapper(t.contactLede) + '</p>'
        + '<form class="lb-form" data-lb-form data-etape="' + S.etape + '" novalidate>';
      var v = S.saisie;
      function champ(id, nom, libelle, attrs, aide) {
        return '<label class="lb-form__label" for="' + id + '">' + echapper(libelle) + '<span class="lb-req">*</span></label>'
          + '<input class="lb-form__input" id="' + id + '" name="' + nom + '" ' + attrs + ' value="' + echapper(v[nom] || '') + '" required>'
          + (aide ? '<p class="lb-form__help">' + echapper(aide) + '</p>' : '');
      }
      if (S.etape === 1) {
        h += '<div class="lb-form__row"><div>' + champ('lb-first', 'first_name', t.firstName, 'type="text" autocomplete="given-name"')
          + '</div><div>' + champ('lb-last', 'last_name', t.lastName, 'type="text" autocomplete="family-name"') + '</div></div>'
          + champ('lb-email', 'email', t.email, 'type="email" autocomplete="email" inputmode="email"', t.emailHelp)
          + champ('lb-phone', 'phone', t.phone, 'type="tel" autocomplete="tel" inputmode="tel"', t.phoneHelp)
          + '<p class="lb-form__error" data-lb-error hidden></p>'
          + '<button type="submit" class="btn btn--primary btn--full lb-cta" data-lb-submit>' + echapper(t.continueBtn) + '</button>'
          + '<p class="lb-form__help lb-form__help--center">' + echapper(t.addressNext) + '</p>';
      } else {
        h += '<p class="lb-form__step">' + echapper(t.billingTitle) + '</p>'
          + champ('lb-street', 'street', t.street, 'type="text" autocomplete="street-address"')
          + '<div class="lb-form__row lb-form__row--zip"><div>' + champ('lb-zip', 'zip', t.zip, 'type="text" autocomplete="postal-code" inputmode="numeric"')
          + '</div><div>' + champ('lb-city', 'city', t.city, 'type="text" autocomplete="address-level2"') + '</div></div>'
          + champ('lb-country', 'country', t.country, 'type="text" autocomplete="country-name"')
          + '<p class="lb-form__error" data-lb-error hidden></p>'
          + '<button type="submit" class="btn btn--primary btn--full lb-cta" data-lb-submit' + (S.envoi ? ' disabled' : '') + '>'
          + (S.envoi ? echapper(t.redirecting) : echapper(t.pay) + ' ' + euros(total())) + '</button>'
          + '<button type="button" class="lb-form__back" data-act="contact-back">' + echapper(t.back) + '</button>';
      }
      h += '<div class="lb-trust__item lb-trust__item--secure">' + ICONES.shield + '<div class="lb-trust__sub">' + echapper(t.secure) + '</div></div>'
        + '</form></div>'
        + '<div class="lb-modal__side"><div class="lb-modal__stay">' + dateCourte(S.arr) + ' → ' + dateCourte(S.dep) + '</div>'
        + '<div class="lb-modal__place">' + echapper(config.title) + ' · ' + echapper(t.travelers) + '</div>';
      h += rendreRecap();
      h += '</div></div></div></div>'; // side, grid, modal, overlay
      return h;
    }

    // Barre sticky mobile : on réutilise celle du thème.
    function majBarreSticky() {
      var from = document.querySelector('.loven-sticky-bar__from');
      var period = document.querySelector('.loven-sticky-bar__period');
      if (!from) return;
      var n = nuits();
      if (n > 0) {
        from.textContent = euros(total());
        if (period) period.textContent = n + ' ' + (n > 1 ? t.nights : t.night) + ' · ' + t.total;
      } else {
        from.textContent = t.from + ' ' + euros(config.fromPriceCents);
        if (period) period.textContent = t.perNight;
      }
    }

    // ---- Interactions ------------------------------------------------
    function ouvrir(quoi) {
      S.ouvert = quoi;
      if (quoi === 'calendar') {
        tracker.envoyer('lns_calendar_open', { month_shown: cle(S.mois).slice(0, 7) });
        if (!S.donnees) chargerMois(S.mois); else { rendre(); verifierDisponibiliteMois(); }
      } else if (quoi === 'options') {
        tracker.envoyer('lns_options_open');
        rendre();
      } else {
        rendre();
      }
      if (quoi && estMobile()) document.body.classList.add('lb-lock');
    }

    function fermer() {
      S.ouvert = null;
      document.body.classList.remove('lb-lock');
      rendre();
    }

    function choisirJour(d) {
      if (!S.arr || S.dep || d <= S.arr) {
        if (!arriveePossible(d)) return;
        S.arr = d; S.dep = null;
        rendre();
        return;
      }
      if (!departPossible(d)) {
        if (arriveePossible(d)) { S.arr = d; S.dep = null; rendre(); }
        return;
      }
      S.dep = d;
      S.devis = null; S.devisErreur = null;
      demanderDevis();
      var n = nuits();
      tracker.envoyer('lns_dates_selected', {
        arrival: cle(S.arr), departure: cle(S.dep), nights: n,
        price_per_night: totalNuits() / n / 100, value: total() / 100, currency: 'EUR',
        lead_time_days: nbNuits(TODAY, S.arr), weekday_arrival: S.arr.getDay()
      });
      fermer();
    }

    function basculerOption(id) {
      var o = (S.donnees.options || []).filter(function (x) { return x.id === id; })[0];
      if (!o) return;
      var coche = !S.opts[o.id];
      S.opts[o.id] = coche;
      demanderDevis();
      var n = nuits() || 1;
      var montant = prixOptionAffiche(o) * (o.per_night ? n : 1) / 100;
      tracker.envoyer(coche ? 'add_to_cart' : 'remove_from_cart', {
        currency: 'EUR', value: montant,
        ecommerce: { items: [{ item_id: 'opt_' + o.id, item_name: o.name, price: montant, quantity: 1 }] }
      });
      rendre();
    }

    function itemsGA4() {
      var items = [{ item_id: config.handle, item_name: config.title, item_category: config.region, item_category2: String(config.spicyness || ''), price: totalNuits() / 100 / nuits(), quantity: nuits() }];
      optionsChoisies().forEach(function (l) {
        items.push({ item_id: 'opt_' + l.opt.id, item_name: l.opt.name, price: prixOptionAffiche(l.opt) / 100, quantity: l.qty });
      });
      return items;
    }

    function demarrerReservation() {
      if (!nuits()) return;
      if (!config.mock && !S.devis) { demanderDevis(); return; }
      tracker.envoyer('begin_checkout', {
        currency: 'EUR', value: total() / 100,
        coupon: S.coupon ? S.coupon.code : undefined,
        ecommerce: { items: itemsGA4() }
      });
      S.etape = 1;
      ouvrir('contact');
      window.setTimeout(function () {
        var inp = racine.querySelector('#lb-first');
        if (inp) inp.focus();
      }, 50);
    }

    // ---- 6. Réservation -------------------------------------------------
    function lireFormulaire(form) {
      Array.prototype.forEach.call(form.querySelectorAll('input[name]'), function (i) { S.saisie[i.name] = (i.value || '').trim(); });
    }

    function soumettre(form) {
      lireFormulaire(form);
      var v = S.saisie;
      var err = form.querySelector('[data-lb-error]');
      function erreur(msg) { err.textContent = msg; err.hidden = false; }

      if (S.etape === 1) {
        if ((v.first_name || '').length < 2 || (v.last_name || '').length < 2) return erreur(t.errInvalidName);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.email || '')) return erreur(t.errInvalidEmail);
        if ((v.phone || '').replace(/\D/g, '').length < 9) return erreur(t.errInvalidPhone);
        // Coordonnees acquises : c'est ici que la relance devient possible,
        // avant meme l'adresse. L'evenement part maintenant, pas au paiement.
        tracker.envoyer('lns_contact_submitted', { has_coupon: !!S.coupon });
        S.etape = 2;
        if (!v.country) S.saisie.country = t.defaultCountry;
        rendre();
        window.setTimeout(function () { var i = racine.querySelector('#lb-street'); if (i) i.focus(); }, 50);
        return;
      }

      if ((v.street || '').length < 4 || (v.zip || '').length < 4 || (v.city || '').length < 2 || (v.country || '').length < 2) return erreur(t.errInvalidAddress);
      err.hidden = true;

      var prenom = v.first_name, nom = v.last_name, email = v.email, phone = v.phone;
      tracker.envoyer('lns_address_submitted', {});
      S.envoi = true;
      rendre();

      var corps = {
        attempt_id: S.attemptId,
        widget: config.widget,
        arrival: cle(S.arr), departure: cle(S.dep),
        options: optionsChoisies().map(function (l) { return l.opt.id; }),
        coupon: S.coupon ? S.coupon.code : null,
        first_name: prenom, last_name: nom,
        address: { street: v.street, zip: v.zip, city: v.city, country: v.country },
        email: email, phone: phone, locale: 'fr-FR',
        expected_total_cents: total(),
        marketing_consent: false
      };

      if (config.mock) {
        window.setTimeout(function () {
          S.envoi = false;
          rendre();
          var e2 = racine.querySelector('[data-lb-error]');
          if (e2) { e2.textContent = t.mockNotice; e2.hidden = false; }
        }, 700);
        return;
      }

      fetch(config.endpoint + '/booking-create', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corps)
      }).then(function (r) {
        return r.json().then(function (json) { return { status: r.status, json: json }; });
      }).then(function (res) {
        if (res.status === 201 && res.json.payment_url) {
          tracker.envoyer('add_payment_info', { currency: 'EUR', value: total() / 100, payment_type: 'bookingmood', attempt_id: S.attemptId, ecommerce: { items: itemsGA4() } });
          window.location.href = res.json.payment_url;
          return;
        }
        S.envoi = false;
        var code = res.json && res.json.error || ('http_' + res.status);
        tracker.envoyer('lns_booking_failed', { error_code: code, attempt_id: S.attemptId });
        if (code === 'price_changed' && res.json.total_cents != null) {
          rendre();
          afficherErreurContact(t.errPriceChanged.replace('{total}', euros(res.json.total_cents)));
        } else if (code === 'unavailable') {
          S.dep = null; S.arr = null;
          fermer();
          ouvrir('calendar');
          S.donnees = null;
          chargerMois(S.mois);
        } else {
          rendre();
          afficherErreurContact(t.errGeneric);
        }
      }).catch(function () {
        S.envoi = false;
        tracker.envoyer('lns_booking_failed', { error_code: 'network', attempt_id: S.attemptId });
        rendre();
        afficherErreurContact(t.errGeneric);
      });
    }

    function afficherErreurContact(msg) {
      var e = racine.querySelector('[data-lb-error]');
      if (e) { e.textContent = msg; e.hidden = false; }
    }

    // ---- 8. Repli iframe ----------------------------------------------
    var replie = false;
    function basculerIframe(raison) {
      if (replie) return;
      replie = true;
      // 'mock' n'est pas un incident mais un garde-fou volontaire : le compter
      // comme un repli fausserait le taux d'echec du widget.
      if (raison !== 'mock') tracker.envoyer('lns_widget_fallback', { reason: raison });
      var tpl = conteneur.querySelector('[data-loven-booking-fallback]');
      if (!tpl) return;
      var frag = tpl.content.cloneNode(true);
      racine.replaceWith(frag);
      conteneur.classList.remove('loven-dates--v2');
      var iframe = conteneur.querySelector('iframe[data-src]');
      if (iframe && !iframe.src) iframe.src = iframe.getAttribute('data-src');
    }

    // ---- Délégation d'événements --------------------------------------
    racine.addEventListener('click', function (ev) {
      var el = ev.target.closest('[data-act]');
      if (!el || !racine.contains(el)) return;
      var a = el.getAttribute('data-act');
      if (a === 'close-contact' && el !== ev.target && !el.classList.contains('lb-modal__close')) return; // clic dans la modale
      switch (a) {
        case 'calendar': if (S.ouvert !== 'calendar') ouvrir('calendar'); break;
        case 'options': ouvrir('options'); break;
        case 'close': case 'close-contact': fermer(); break;
        case 'contact-back': lireFormulaire(racine.querySelector('[data-lb-form]')); S.etape = 1; rendre(); break;
        case 'prev': S.mois = moisSuivant(S.mois, -1); rendre(); if (!nuit(S.mois)) chargerMois(S.mois); else verifierDisponibiliteMois(); break;
        case 'next': S.mois = moisSuivant(S.mois, 1); rendre(); if (!nuit(moisSuivant(S.mois, estMobile() ? 0 : 1))) chargerMois(S.mois); else verifierDisponibiliteMois(); break;
        case 'clear': S.arr = null; S.dep = null; S.devis = null; S.devisCle = null; S.devisErreur = null; if (el.textContent.trim() === t.close) fermer(); else rendre(); break;
        case 'day': choisirJour(new Date(Number(el.getAttribute('data-t')))); break;
        case 'opt': basculerOption(el.getAttribute('data-id')); return;
        case 'coupon-on': appliquerCoupon(); return;
        case 'coupon-off': S.coupon = null; S.couponErreur = null; demanderDevis(); rendre(); return;
        case 'book': demarrerReservation(); break;
      }
    });

    racine.addEventListener('submit', function (ev) {
      var form = ev.target.closest('[data-lb-form]');
      if (!form) return;
      ev.preventDefault();
      if (!S.envoi) soumettre(form);
    });

    racine.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && ev.target.hasAttribute('data-lb-coupon')) {
        ev.preventDefault();
        appliquerCoupon();
      }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && S.ouvert) fermer();
    });

    // Fermer le calendrier / la popin options au clic en dehors (desktop).
    // composedPath() plutôt que racine.contains() : après un re-rendu, la cible
    // du clic n'est plus dans le DOM, mais le chemin de l'événement, lui, est figé.
    document.addEventListener('click', function (ev) {
      if (!S.ouvert || S.ouvert === 'contact' || estMobile()) return;
      var chemin = ev.composedPath ? ev.composedPath() : [];
      if (chemin.indexOf(racine) === -1 && !racine.contains(ev.target)) fermer();
    });

    // ---- Garde-fou demonstration ---------------------------------------
    // Le mock sert a developper l'interface avant que booking-availability
    // existe. Ses tarifs et ses options sont ceux du Lien : les afficher sur
    // une autre fiche, c'est mentir au visiteur sur le prix. Tant que
    // config.mock est vrai, le widget ne s'affiche donc que sur une page
    // ouverte en ?lns_widget=v2 ; partout ailleurs on rend l'iframe
    // Bookingmood, qui est fausse mais juste.
    // A retirer le jour ou config.mock passe a false.
    if (config.mock && !APERCU) {
      basculerIframe('mock');
      return;
    }

    // ---- Premier rendu -------------------------------------------------
    tracker.envoyer('view_item', {
      currency: 'EUR', value: config.fromPriceCents / 100,
      ecommerce: { items: [{ item_id: config.handle, item_name: config.title, item_category: config.region, item_category2: String(config.spicyness || ''), price: config.fromPriceCents / 100 }] }
    });
    rendre();
    // Précharge la fenêtre courante : le calendrier s'ouvre sans attente.
    chargerMois(S.mois);

    window.LovenBooking = window.LovenBooking || [];
    window.LovenBooking.push({ state: S, config: config });
  }

  // ------------------------------------------------------------------
  // 9. Initialisation paresseuse : uniquement l'instance visible
  //    (le thème en rend une pour desktop et une pour mobile).
  // ------------------------------------------------------------------
  // Mode aperçu : ?lns_widget=v2 sur n'importe quelle fiche remplace l'iframe
  // par le widget sans toucher au métafield hebergement.widget_v2. Sert aux tests
  // avant la bascule ; à retirer quand le flag est généralisé.
  // ------------------------------------------------------------------
  // Mode test — comment essayer le widget sans toucher au theme
  // ------------------------------------------------------------------
  // Trois parametres d'URL, memorises pour la duree de l'onglet (sessionStorage)
  // pour qu'ils survivent a la navigation interne :
  //
  //   ?lns_widget=v2      monte le widget a la place de l'iframe, sur
  //                       n'importe quelle fiche, sans metafield.
  //   ?lns_data=live      force les vraies donnees : le widget appelle
  //                       booking-availability au lieu du mock. C'est le mode
  //                       preprod. Implique lns_widget=v2.
  //   ?lns_data=mock      force le mock, meme apres la bascule.
  //   ?lns_api=<ref>      pointe vers un autre projet Supabase (20 lettres
  //                       minuscules, format d'un project ref). Sert a taper
  //                       une preprod plutot que la production.
  //   ?lns_test=off       oublie tout et revient au comportement normal.
  //
  // Rien de tout cela n'est accessible a un visiteur ordinaire, et rien n'est
  // persistant au-dela de l'onglet : un lien partage par erreur n'a aucun effet
  // durable. Le bandeau en haut du widget dit toujours dans quel mode on est.
  var APERCU = false;
  var MODE_DONNEES = null;   // null | 'live' | 'mock'
  var API_REF = null;

  function lireModeTest() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }

    var memoire = {};
    try { memoire = JSON.parse(window.sessionStorage.getItem('lns_test') || '{}'); } catch (e) { memoire = {}; }

    if (params.get('lns_test') === 'off') {
      try { window.sessionStorage.removeItem('lns_test'); } catch (e) {}
      return;
    }

    if (params.get('lns_widget') === 'v2') memoire.widget = true;

    var donnees = params.get('lns_data');
    if (donnees === 'live' || donnees === 'mock') memoire.data = donnees;

    var ref = params.get('lns_api');
    // Un project ref Supabase, et rien d'autre : on ne laisse pas une URL
    // arbitraire entrer dans un fetch depuis un parametre d'URL.
    if (ref && /^[a-z]{20}$/.test(ref)) memoire.api = ref;

    if (memoire.data === 'live') memoire.widget = true;

    if (memoire.widget || memoire.data || memoire.api) {
      try { window.sessionStorage.setItem('lns_test', JSON.stringify(memoire)); } catch (e) {}
    }

    APERCU = !!memoire.widget;
    MODE_DONNEES = memoire.data || null;
    API_REF = memoire.api || null;
  }

  function activerApercu() {
    lireModeTest();
    if (!APERCU) return;
    document.querySelectorAll('template[data-loven-booking-preview]').forEach(function (tpl) {
      var ancien = tpl.previousElementSibling;
      if (!ancien || !ancien.classList.contains('loven-dates')) return;
      ancien.replaceWith(tpl.content.cloneNode(true));
      tpl.remove();
    });
    document.body.classList.add('loven-booking-preview');
  }

  function demarrer() {
    activerApercu();
    var racines = document.querySelectorAll('[data-loven-booking]');
    if (!racines.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      racines.forEach(function (r) { if (r.offsetParent !== null) initialiser(r); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        if (!e.target.hasAttribute('data-loven-booking-init')) {
          e.target.setAttribute('data-loven-booking-init', '1');
          initialiser(e.target);
        }
      });
    }, { rootMargin: '200px 0px' });
    racines.forEach(function (r) { obs.observe(r); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
